// extracted by mini-css-extract-plugin
module.exports = {"btn-icon":"icon-button_btn-icon__mXYIn","with-border":"icon-button_with-border__yhYlu","text-part":"icon-button_text-part__tLSZl","icon-part":"icon-button_icon-part__Bwm8Q"};